"use client";
/**
 * The family's one card surface.
 *
 * It exists so the variant modifier is written in exactly one place: the kit's
 * shell owns the geometry, the three regions and the radius rung, and this
 * wrapper only decides which BEM modifier and which debug path the audit
 * tooling reads. The name and the modifier arrive together because not every
 * surface here is one of the three card compositions — the rail card and the
 * plan are their own, and each stamps its own name rather than borrowing
 * whichever card the panel has selected.
 */
import type { ReactElement, ReactNode } from "react";
import {
  CresultcardShell,
  type CresultcardDensity,
} from "@/components/ui/Cresultcard";

const ROOT_CLASS_NAME = "cworkoutcard";
const CLASS_NAME_SEPARATOR = " ";

interface CworkoutcardShellProps {
  /** The composition's own name, stamped for the audit tooling. */
  readonly variant: string;
  /** That composition's BEM modifier, declared beside the name in constants. */
  readonly modifier: string;
  readonly density: CresultcardDensity;
  readonly head?: ReactNode;
  readonly body: ReactNode;
  readonly foot?: ReactNode;
  readonly openable?: boolean;
}

export function CworkoutcardShell({
  variant,
  modifier,
  density,
  head,
  body,
  foot,
  openable = false,
}: CworkoutcardShellProps): ReactElement {
  return (
    <CresultcardShell
      body={body}
      className={[ROOT_CLASS_NAME, modifier].join(CLASS_NAME_SEPARATOR)}
      density={density}
      foot={foot}
      head={head}
      openable={openable}
      variant={variant}
    />
  );
}
